
/**
 * @imports
 */
import Reflex from './index.js';

// As globals
if (!window.WebNative) {
	window.WebNative = {};
}
window.WebNative.Reflex = Reflex;
